import React, { Component } from 'react'
import Box from './Box'

class CollapsableBox extends Component {
  render () {
    return (
      <Box key={!!this.props.key ? this.props.key + '_box' : undefined} collapsable {...this.props}>
        {this.props.children}
      </Box>
    )
  }
}
export default CollapsableBox



// WEBPACK FOOTER //
// ./src/components/basic/containers/CollapsableBox.js